import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@rq-ratings/pro-solid-svg-icons'
import classNames from 'classnames'
import React from 'react'

import useAppDispatch from '../../../../../../hooks/useAppDispatch'
import { buildCompanyCompassUrl } from '../../../../../../lib/helpers/routeHelpers'
import { ROUTES } from '../../../../../../lib/routes'
import {
  resetCompass,
  startCompass,
} from '../../../../../../redux/slices/compass'
import { COMPASS_STEPS } from '../../../../../flows/CompassFlow/constants'
import ActionLink from '../../../../../misc/ActionLink'
import NavigationButton from '../../../../../misc/NavigationButton'
import NavigationButtonsContainer from '../../../../../misc/NavigationButtonsContainer'
import PageTitle from '../../../../../typography/PageTitle'
import CompanyCompassLink from './CompanyCompassLink'

type Props = Omit<React.HTMLAttributes<HTMLDivElement>, 'children'>

const CompassPageHeader: React.FC<Props> = ({ className }) => {
  const dispatch = useAppDispatch()

  return (
    <section className="mb-3">
      <header
        className={classNames(
          'd-flex flex-column flex-md-row flex-row flex-wrap align-items-md-center gap-3 column-gap-4 mb-4 mb-md-3 w-100',
          className,
        )}
      >
        <PageTitle className="mb-none">Compass</PageTitle>

        <div className="d-flex flex-row flex-wrap align-items-center gap-3 gap-md-4">
          <NavigationButtonsContainer>
            <NavigationButton
              to={ROUTES.companyCompassDashboard}
              label="Dashboard"
            />

            <NavigationButton
              to={ROUTES.companyCompassSnapshots}
              label="Snapshots"
            />

            <NavigationButton
              to={ROUTES.companyCompassGlobalLink}
              label="Global link"
            />
          </NavigationButtonsContainer>

          <ActionLink
            to={buildCompanyCompassUrl({ step: COMPASS_STEPS.inviteClients })}
            className="w-100 w-md-auto d-flex align-items-center justify-content-center text-center text-md-start"
            data-element="invite-clients-btn"
            beforeNavigate={() => {
              dispatch(startCompass(COMPASS_STEPS.inviteClients))
            }}
            style={{ minWidth: '100px' }}
          >
            <FontAwesomeIcon
              icon={faPlus}
              style={{ fontSize: '13px', marginRight: '5px' }}
            />
            Invite clients
          </ActionLink>
        </div>
      </header>

      <div className="d-flex row-gap-4 column-gap-3 align-items-center flex-wrap">
        <ActionLink
          beforeNavigate={() => dispatch(resetCompass())}
          to={ROUTES.companyCompass}
          className="d-flex align-items-center justify-content-center btn btn-primary btn-lg btn-fluid text-center"
          style={{ gap: '8px' }}
        >
          <FontAwesomeIcon icon={faPlus} style={{ fontSize: '16px' }} />
          Start Compass
        </ActionLink>
        <CompanyCompassLink />
      </div>
    </section>
  )
}

export default CompassPageHeader
